<template>
  <div class="mask-box-wrap" v-show="isShow">
    <div class="mask-box" @click="handleClose"></div>
    <div class="content-box">
      <div class="title">{{title}}</div>
      <div class="item-box">
        <div
          class="item"
          v-for="(item,index) in dataList"
          :key="index"
          @click="handleSelect(item)"
        >{{item.dicName}}</div>
      </div>
      <div class="btn" @click="handleClose">取消</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dataList: Array,
    title: String,
    isShow: Boolean
  },
  data() {
    return {}
  },
  methods: {
    handleClose() {
      this.$emit('handle-close')
    },
    handleSelect(item) {
      this.$emit('handle-select', item)
    }
  }
}
</script>
<style lang="less" scoped>
.mask-box-wrap {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  .mask-box {
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    width: 100%;
    height: 100%;
  }
  .content-box {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    text-align: center;
    background-color: rgb(248, 248, 248);
    .title {
      font-size: 0.3rem;
      color: rgb(153, 153, 153);
      height: 0.92rem;
      line-height: 0.92rem;
      border-bottom: 0.01rem solid rgb(238, 238, 238);
      background: #fff;
    }
    .item-box {
      max-height: 3.68rem;
      margin-bottom: 0.16rem;
      background: #fff;
      overflow: auto;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .item {
        height: 0.92rem;
        line-height: 0.92rem;
        list-style: height 0.92rem;
        font-size: 0.3rem;
        color: rgb(51, 51, 51);
        &:not(:last-child) {
          border-bottom: 0.01rem solid rgb(238, 238, 238);
        }
      }
    }
    .btn {
      height: 0.94rem;
      line-height: 0.94rem;
      color: rgb(51, 51, 51);
      font-size: 0.3rem;
      background: #fff;
    }
  }
}
</style>
